// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lo-0";
export var buttonContainer = "_lo-3";
export var cancelButton = "_lo-4";
export var headerSection = "_lo-6";
export var headerTitle = "_lo-9";
export var messageSideLeft = "_lo-1";
export var messageSideRight = "_lo-2";
export var orderNumberContainer = "_lo-7";
export var orderNumberLabel = "_lo-8";
export var submitButton = "_lo-5";